import { post, get, formPost } from "./Http";
let baseUrl = "api-tax-personal-income-server"
function PersonnelImport(query) {
  return post(`/${baseUrl}/excel/import/personal`, query);
}
//首页条件查询
function GetPersonalInfo(query) {
  return post(`/${baseUrl}/personal-user-info/getPersonalInfo`, query);
}
//保存
function SavePersonalInfo(query) {
  return post(`/${baseUrl}/personal-user-info/savePersonalInfo`, query);
}
//导出
function GetPersonal(query) {
  return formPost(`/${baseUrl}/excel/export/personal`, query);
}
//报送
function SendPersonalInfo(query) {
  return post(`/${baseUrl}/personal-user-info/sendPersonalInfo`, query);
}
//修改
function UpdatePersonalInfo(query) {
  return post(`/${baseUrl}/personal-user-info/updatePersonalInfo`, query);
}
//详情
function getPersonalInfoDetail(query) {
  return post(`/${baseUrl}/personal-user-info/getPersonalInfoDetail`,query);
}
//删除
function delPersonalInfo(query) {
  return post(`/${baseUrl}/personal-user-info/delPersonalInfo`,query);
}
//省市区
function RegionInfo(query) {
  return get(`/${baseUrl}/region/regionInfo`,query);
}
// 辅助工资查询人员列表
function personalList(query){
  return post(`/${baseUrl}/personal-user-info/getPersonalInfoForGZ`,query)
}
// 平台导入模板列表
function getEduFiles(query){
  return get(`/${baseUrl}/excel/getEduFiles`, query)
}
//平台模板人员导入接口
function platform(query){
  return post(`/${baseUrl}/excel/import/personal/platform`,query)
}
//平台专项导入接口
function specialPlatform(query){
  return post(`/${baseUrl}/excel/import/specialDeduction/platform`,query)
}
// 平台模板正常工资薪金所得导入
function WagePlatform(query) {
  return post(`/${baseUrl}/excel/import/wage/platform`,query)
}
// 平台导入劳务报酬（一般劳务，其他非连续劳务）
function generalLabour(query) {
  return post(`/${baseUrl}/excel/import/generalLabour/platform`,query)
}
// 平台导入全年一次性奖金收入平台导入接口
function bonusPlatform(query) {
  return post(`/${baseUrl}/excel/import/bonusIncome/platform`,query)
}
// 平台导入稿酬所得
function remunerationPlatform(query) {
  return post(`/${baseUrl}/excel/import/remuneration/platform`,query)
}
// 平台导入特许权使用费
function rconcessionsPlatform(query) {
  return post(`/${baseUrl}/excel/import/concessions/platform`,query)
}
// 平台导入个人养老金缴费
function personalPensionPlatform(query) {
  return post(`/${baseUrl}/excel/import/personalPension/platform`,query)
}
// 平台导入分类所得-利息、股息、红利所得
function dividendPlatform(query) {
  return post(`/${baseUrl}/excel/import/dividend/platform`,query)
}
// 平台导入分类所得-财产转让所得
function transferPropertyPlatform(query) {
  return post(`/${baseUrl}/excel/import/transferProperty/platform`,query)
}
// 平台导入分类所得-财产租赁所得
function leasePropertyPlatform(query) {
  return post(`/${baseUrl}/excel/import/leaseProperty/platform`,query)
}
// 平台导入分类所得-偶然所得
function contingentIncomePlatform(query) {
  return post(`/${baseUrl}/excel/import/contingentIncome/platform`,query)
}
export default {
  PersonnelImport,
  GetPersonalInfo,
  GetPersonal,
  SendPersonalInfo,
  UpdatePersonalInfo,
  SavePersonalInfo,
  getPersonalInfoDetail,
  RegionInfo,
  delPersonalInfo,
  personalList,
  getEduFiles,
  platform,
  WagePlatform,
  generalLabour,
  specialPlatform,
  bonusPlatform,
  remunerationPlatform,
  rconcessionsPlatform,
  personalPensionPlatform,
  dividendPlatform,
  transferPropertyPlatform,
  leasePropertyPlatform,
  contingentIncomePlatform
}



// WEBPACK FOOTER //
// ./src/api/personalInfoApi.js